import React from 'react';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';
import { TCIDropdown } from '@/components/ui/Dropdown';
import { useModalManager } from '@/components/common/Modal';
import { RemoveSlideGroupModal } from '@/components/admin/SlideShow/Utils/RemoveSlideGroup';
import { SlideGroup } from '@/components/admin/SlideShow/Builder/CreateTransistionGroup/utils';
import builderStyles from '../SlideShowBuilder.module.scss';

interface SlideGroupCardActionsProps {
  card: SlideGroup;
}

// Events from the menu bubble through React to the card, which selects on click; stop them here.
const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

const SlideGroupCardActions = ({ card }: SlideGroupCardActionsProps) => {
  const removeModalManager = useModalManager();

  return (
    <div
      className={builderStyles.actionsButtonWrapper}
      role="presentation"
      onClick={stopPropagation}
      onKeyDown={stopPropagation}
      onMouseDown={stopPropagation}
    >
      <TCIDropdown align="start">
        <TCIDropdown.Trigger asChild>
          <button
            aria-label={I18n.t('actions')}
            className={cn(builderStyles.actionsButton, 'dropdown-toggle btn btn--outline-purple')}
            type="button"
          />
        </TCIDropdown.Trigger>
        <TCIDropdown.Content width="unset">
          <TCIDropdown.Item onSelect={removeModalManager.open}>
            {I18n.t('delete_slide_group')}
          </TCIDropdown.Item>
        </TCIDropdown.Content>
      </TCIDropdown>

      <RemoveSlideGroupModal modalManager={removeModalManager} slideGroup={card} />
    </div>
  );
};

export default SlideGroupCardActions;
